import { LeagueType } from '~/Leaderboard/types/leaderboard.types'

export function getLeagueBadgeSrcKey(leagueRank: {
  data?: { currentLeague: number; highestLeague: number }
}): { currentLeague: string; highestLeague: string; leagueNumber: number; highestLeagueNumber: number } | undefined {
  const currentLeague = Object.entries(LeagueType)
    .filter(([, value]) => value === leagueRank.data?.currentLeague)
    .map(([key]) => key)
    .toString()

  const highestLeague = Object.entries(LeagueType)
    .filter(([, value]) => value === leagueRank.data?.highestLeague)
    .map(([key]) => key)
    .toString()

  if (!currentLeague || !highestLeague) return undefined

  return {
    currentLeague: `gamification/badges/league/${currentLeague.toLowerCase()}-badge.svg`,
    highestLeague: `gamification/badges/league/${highestLeague.toLowerCase()}-badge.svg`,
    leagueNumber: leagueRank.data?.currentLeague || 0,
    highestLeagueNumber: leagueRank.data?.highestLeague || 0,
  }
}
